import api from '../../../helpers/api';

export const getPendingSupplierProducts = (body) =>
  api.post('supplier-product-staging/search-supplier-products', { ...body });

export const updatePendingSupplierProduct = (body) =>
  api.post('moderation-pool/moderate-suppliers-products', { ...body });

export const getSinglePendingSupplierProdcut = (id) =>
  api.get(`/supplier-product-staging/${id}`);

export const deleteSinglePendingSupplierProduct = (id) => api.delete(`supplier-product-staging/${id}`)

export const moderateCreateSinglePendingSupplierProduct = (id) => api.post(`supplier-product-staging/moderate-create-supplier-product`,id)
export const moderateUpdateSinglePendingSupplierProduct = (id) => api.post(`supplier-product-staging/moderate-update-supplier-product`,id)